import React, { useEffect, useState } from 'react';
import "react-popupbox/dist/react-popupbox.css";
import '../../assets/css/global.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CreateNFCAlbum from '../../apis/createNFCAlbum/createNFCAlbum';
import { useNavigate } from 'react-router-dom';
const UploadAfcAlbum = ({ closeAlbumPopup, album }) => {
    const [mode, setMode] = useState(""); // "audio" | "event"

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [eventUrl, setEventUrl] = useState('');
    const [specialMessage, setSpecialMessage] = useState('');
    const [image, setImage] = useState(null);
    const [imageName, setImageName] = useState('');
    const [isPublicLibrary, setisPublicLibrary] = useState(false);
    const [titleError, setTitleError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    const [eventUrlError, setEventUrlError] = useState('');
    const [imageError, setImageError] = useState('');
    const [albumPicEdit, setAlbumPic] = useState('');
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const fetchImageAsFile = async (imageUrl) => {
        try {
            const response = await fetch(imageUrl);
            if (!response.ok) throw new Error('Failed to fetch image');

            const blob = await response.blob();

            const urlParts = imageUrl.split('/');
            let filename = urlParts[urlParts.length - 1].split('?')[0];

            filename = filename.replace(/\d+_*/g, '');
            filename = filename.replace(/^[^\w]+|[^\w]+$/g, '');
            filename = filename || 'image.jpg';

            const file = new File([blob], filename, { type: blob.type });
            console.log('file', file)
            return file;
        } catch (error) {
            console.error('Error fetching image as file:', error);
            return null;
        }
    };
    useEffect(() => {
       

        if (album) {
            setTitle(album.title || '');
            setDescription(album.description || '');
            setEventUrl(album.eventUrl || '');
            setSpecialMessage(album.specialMessage || '');
            setisPublicLibrary(album.isPublicLibrary || false);
            setAlbumPic(album.albumPic);
            if (album.eventUrl && album.eventUrl !== 'album') {
                setMode("event");
            } else if(album.title) {
                setMode("audio");
            }
            if (album.albumPic) {
                console.log('[useEffect] albumPic exists, fetching…');
                fetchImageAsFile(album.albumPic)
                    .then(file => {
                        console.log('[fetchImageAsFile] returned file:', file);
                        setImage(file);
                        setImageName(file.name);
                        console.log('[useEffect] setImage & setImageName called with:', file.name);
                    })
                    .catch(error => console.error('Error converting image:', error));
            }
        }
    }, [album]);

    const handleTitleChange = (e) => {
        setTitle(e.target.value);
        setTitleError(e.target.value.trim() ? "" : "This field is required.");
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
        setDescriptionError(e.target.value.trim() ? "" : "This field is required.");
    };

    const handleEventUrlChange = (e) => {
        setEventUrl(e.target.value);
        setEventUrlError(e.target.value.trim() ? "" : "Event URL is required.");
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) {
            setImageError("The Banner is required.");
            return;
        }

        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/avif', 'application/pdf'];
        if (!allowedTypes.includes(file.type)) {
            setImageError("Invalid file type.");
            return;
        }

       

        setImage(file);
        setImageName(file.name);
        setImageError("");
    };

    const handleSpecialMessageChange = (e) => setSpecialMessage(e.target.value);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate
        let hasError = false;
        if (!title.trim()) { setTitleError("This field is required."); hasError = true; } else setTitleError("");
        if (mode === "audio" && !description.trim()) { setDescriptionError("This field is required."); hasError = true; } else setDescriptionError("");
        if (mode === "event" && !eventUrl.trim()) { setEventUrlError("Event URL is required."); hasError = true; } else setEventUrlError("");

        if (hasError) return;

        setLoading(true);

        const formData = new FormData();
        formData.append('Title', title);
        formData.append('Description', description);
        formData.append('SpecialMessage', specialMessage);
        formData.append('isPublicLibrary', isPublicLibrary ? 1 : 0);
        //if (image) formData.append('AlbumCover', image);

        if (mode === 'audio') {
            formData.append('EventURL', 'album');
            formData.append('Type',1);
        }
        else {
            formData.append('EventURL', eventUrl);
            formData.append('Type',2);
        }
        if (album.id) {
            formData.append('AlbumId', album.id);
            formData.append('FolderName', albumPicEdit)
            if (image) {

                formData.append('IsPicChanged', true);
                formData.append('AlbumCover', image);
            } else {
                formData.append('IsPicChanged', false);
                 formData.append('AlbumCover', '');

            }
        } else {
            formData.append('AlbumId', "0");
            formData.append('FolderName', '')
            if (image) {
                formData.append('IsPicChanged', true);
                formData.append('AlbumCover', image);
            }
            else{
                 formData.append('IsPicChanged', false);
                 formData.append('AlbumCover', '');
            }
        }
        console.log("FormData entries:");
        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }

        try {
            const authenticationToken = sessionStorage.getItem('token');
            const response = await CreateNFCAlbum(authenticationToken, formData);
            if (response.result === 1 && response.errorValue === null) {

                if (album.title) {
                    toast.success('NCF Album successfully updated!');
                    setTimeout(() => {
                        closeAlbumPopup();

                    }, 1000);
                } else {
                    toast.success('NCF Album successfully created!');


                }
                setTitle(title);
                setImage(null);
                setImageName('');
                setDescription('');

            } else if (response.result === 0 && response.errorValue && response.errorValue.errorCode === 103) {
                console.error('Invalid authentication token:', response.errorValue.errorText);
                sessionStorage.clear();
                navigate('/');
            } else {
                console.error('API call returned an error:', response);
            }
        } catch (error) {
            console.error('API call error:', error);
        } finally {
            setLoading(false);
        }
    };
   
    return (
        <>
            <div className="popup-fixed"></div>
            <div className="popup-container popup-container-fixed">
                <div className="login-popup">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 m-auto shadow">
                                <div className="row relative">
                                    <div className="col-md-12">
                                        <span className="close-popup" onClick={closeAlbumPopup}></span>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="album-add">

                                            {/* Step 1: Choose mode */}
                                            {!mode && (
                                                <div className="choose-mode text-center">
                                                    <h4>Which Type of Album do you want to create?</h4>
                                                    <div className="mode-buttons">
                                                        <button type="button" className="btn-submit" onClick={() => setMode("audio")}>
                                                            Audio Track
                                                        </button>
                                                        <button type="button" className="btn-submit" onClick={() => setMode("event")}>
                                                            Event Page
                                                        </button>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Step 2: Form */}
                                            {mode && (
                                                <form onSubmit={handleSubmit}>
                                                    {/* Title */}
                                                    <div className="margin-bottom">
                                                        <input
                                                            type="text"
                                                            className="input"
                                                            placeholder={mode === "audio" ? "Name of the album" : "Event Title"}
                                                            value={title}
                                                            onChange={handleTitleChange}
                                                            disabled={isLoading}
                                                        />
                                                        {titleError && <span className="error">{titleError}</span>}
                                                    </div>

                                                    {/* Description / Poster Detail */}
                                                    <div className="margin-bottom">
                                                        <textarea
                                                            className="input"
                                                            placeholder={mode === "audio" ? "Description" : "Poster Detail"}
                                                            value={description}
                                                            onChange={handleDescriptionChange}
                                                            disabled={isLoading}
                                                        ></textarea>
                                                        {descriptionError && <span className="error">{descriptionError}</span>}
                                                    </div>

                                                    {/* Event URL only for Event Page */}
                                                    {mode === "event" && (
                                                        <div className="margin-bottom">
                                                            <input
                                                                type="text"
                                                                className="input"
                                                                placeholder="Event Page URL"
                                                                value={eventUrl}
                                                                onChange={handleEventUrlChange}
                                                                disabled={isLoading}
                                                            />
                                                            {eventUrlError && <span className="error">{eventUrlError}</span>}
                                                        </div>
                                                    )}

                                                    {/* Upload Banner */}
                                                    <div className="margin-bottom flex items-center justify-between gap-6 row">
                                                        {/* Upload */}
                                                        <div className={`flex-1 max-w-xs ${mode === "event" ? "col-12" : "col-7"}`}>
                                                            <label
                                                                htmlFor="file-upload"
                                                                className="custom-file-upload block text-center px-4 py-2 bg-gray-300 rounded cursor-pointer"
                                                            >
                                                                Upload banner
                                                            </label>
                                                            <input
                                                                id="file-upload"
                                                                type="file"
                                                                onChange={handleImageChange}
                                                                disabled={isLoading}
                                                                className="hidden"
                                                            />
                                                            {imageError && <span className="error">{imageError}</span>}
                                                            {imageName && (
                                                                <p className="albumCover text-sm mt-1">
                                                                    Uploaded: {imageName}
                                                                </p>
                                                            )}
                                                            {!imageName && albumPicEdit && (
                                                                <p className="albumCover text-sm mt-1">
                                                                    Current: {albumPicEdit.split('/').pop().split('?')[0]}
                                                                </p>
                                                            )}
                                                        </div>

                                                        {/* Toggle field */}
                                                        {mode === "audio" && (
                                                            <div className="margin-bottom flex items-center gap-2 col-5">
                                                                <label htmlFor="isPrimary" className="text-sm font-medium">
                                                                    Public Library
                                                                </label>
                                                                <label className="switch">
                                                                    <input
                                                                        id="isPublicLibrary"
                                                                        type="checkbox"
                                                                        checked={isPublicLibrary}
                                                                        onChange={(e) => setisPublicLibrary(e.target.checked)}
                                                                        disabled={isLoading}
                                                                        name="isPublicLibrary"
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                        )}
                                                    </div>


                                                    {/* Special Message */}
                                                    <div className="margin-bottom">
                                                        <textarea
                                                            className="input"
                                                            placeholder="Special Message"
                                                            value={specialMessage}
                                                            onChange={handleSpecialMessageChange}
                                                            disabled={isLoading}
                                                        ></textarea>
                                                    </div>

                                                    <div className="align-center">
                                                        <input
                                                            type="submit"
                                                            className={`btn-submit ${isLoading ? "disabled" : ""}`}
                                                            value="Submit"
                                                            disabled={isLoading}
                                                        />
                                                        {isLoading && <span className="albumloader">Loading...</span>}
                                                    </div>
                                                </form>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default UploadAfcAlbum;
